export default "__VITE_ASSET__ki094r3j__"